import { inject, observer } from "mobx-react";
import { read, utils } from "xlsx";

import UploadUI from "@UI/UploadUI";
import { pluralForm } from "@utils";
import moment from "moment";

import "./style.scss";

const ActivateFileActivation = inject("mainStore")(
    observer(({ mainStore }) => {
        const handleUpload = async (event) => {
            const file = event.files[0];
            const reader = new FileReader();

            reader.onload = async (e) => {
                const bstr = e.target.result;
                const wb = read(bstr, { type: "array" });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];

                const dataCodes = utils.sheet_to_json(ws, { header: 1 }).map((i, idx) => {
                    const cellAddress = utils.encode_cell({ r: idx, c: 0 });
                    const cellBid = utils.encode_cell({ r: idx, c: 3 });
                    const bidCell = ws?.[cellBid];
                    const cell = ws?.[cellAddress];
                    let isoDate = null;

                    if (cell) {
                        // console.log(cell);

                        if (cell.t === "n") {
                            isoDate = moment(cell.w, "D/M/YY").format("YYYY-MM-DD");
                            // Числовой формат Excel (например, 45666)
                            // const dateObj = new Date((cell.v - 25569) * 86400000);
                            // if (!isNaN(dateObj.getTime())) {
                            //     isoDate = dateObj.toISOString().split("T")[0]; // 'YYYY-MM-DD'
                            // }
                        } else if (cell.t === "s" && typeof cell.v === "string") {
                            // Строковый формат 'DD.MM.YYYY'
                            const parts = cell.v.split(".");
                            if (parts.length === 3) {
                                const [day, month, year] = parts;
                                // Валидация: все части должны быть числами
                                if (day && month && year && /^\d+$/.test(day) && /^\d+$/.test(month) && /^\d+$/.test(year)) {
                                    const y = year.length === 2 ? `20${year}` : year; // на случай 25 → 2025
                                    const d = day.padStart(2, "0");
                                    const m = month.padStart(2, "0");
                                    isoDate = `${y}-${m}-${d}`;
                                }
                            }
                        }
                    }
                    console.log("bidCell", bidCell);

                    let number = 0;
                    if (bidCell?.t && bidCell?.w && ["n", "s"].includes(bidCell.t)) {
                        // если тип строка или число
                        // забираем строку а не цифру, так как в цифре уже удалены разделители
                        number = parseFloat(
                            bidCell.w
                                .replace(/[^\d,]/g, "") // Удаляем всё, кроме цифр и запятых
                                .replace(",", "."),
                        );
                    }

                    return { date: isoDate, offerId: i[1], count: i[2], bids: number };
                });

                const obj = { activationObjectArray: dataCodes, type: "fileWithActivations" };

                console.log(obj);

                const resp = await mainStore.postByUrl(`/promo/upload_activatios_by_type`, obj);

                if (resp && resp.success) {
                    event.options.clear();
                    mainStore.setMainStore("toast", { severity: "success", summary: `Было найдено ${resp.data.createOrUpdate} активац${pluralForm(resp.data.createOrUpdate, ["ия", "ии", "ий"])}.` });
                }
            };

            reader.readAsArrayBuffer(file);
        };

        return (
            <div className="activate__file">
                <UploadUI handleUpload={handleUpload} formats="CSV" />
            </div>
        );
    }),
);

export default ActivateFileActivation;
